export const ALL_LOCALES_VALUE = 'all' as const;
